import * as React from "react"
import { ReactElement, FC } from "react";
import AppUtils from "../../utils/AppUtils";

interface RenderConfidentialDataProps {
    children?: ReactElement;
    showText?: boolean;
}

const RenderConfidentialData : FC<RenderConfidentialDataProps> = ({children = null, showText = false}) => { 
    if(!children || children == null) return null;

    let className = `${AppUtils.renderConfidentialData() ? '' : 'confidential-data'} ${showText ? 'show-text' : ''}`

    if(typeof children === 'string') return <div className={className}>{children}</div>

    return React.cloneElement(children, {       
        className: `${children.props.className ? children.props.className : ''} 
                    ${className}`
    })
}

export default RenderConfidentialData